import * as React from 'react'
import styled from 'styled-components'
import { ViewBase } from '@bestyled/primitives'
import { commonProps, CommonProps } from '@bestyled/system'

function alignmentToMainAxisDirection(alignment) {
  switch (alignment) {
    case 'bottom-left':
    case 'top-left':
    case 'center-left':
    case 'ninebox7':
    case 'ninebox4':
    case 'ninebox1':
      return 'flex-start'

    case 'bottom-right':
    case 'top-right':
    case 'center-right':
    case 'ninebox9':
    case 'ninebox6':
    case 'ninebox3':
      return 'flex-end'

    case 'ninebox8':
    case 'ninebox5':
    case 'ninebox2':
    case 'bottom-center':
    case 'top-center':
    case 'center-center':
    case 'center':
      return 'center'

    default:
      return alignment
  }
}

function alignmentToCrossAxisDirection(alignment) {
  switch (alignment) {
    case 'bottom-left':
    case 'bottom-right':
    case 'bottom-center':
    case 'ninebox7':
    case 'ninebox8':
    case 'ninebox9':
      return 'flex-end'

    case 'ninebox1':
    case 'ninebox2':
    case 'ninebox3':
    case 'top-left':
    case 'top-center':
    case 'top-right':
      return 'flex-start'

    case 'ninebox4':
    case 'ninebox5':
    case 'ninebox6':
    case 'center-left':
    case 'center-right':
    case 'center-center':
    case 'center':
      return 'center'

    default:
      return alignment
  }
}

export interface AlignProps extends CommonProps {
  alignment:
    | 'bottom-center'
    | 'bottom-right'
    | 'bottom-left'
    | 'center'
    | 'center-center'
    | 'center-left'
    | 'center-right'
    | 'top-left'
    | 'top-center'
    | ' top-right'
    | 'ninebox1'
    | 'ninebox2'
    | 'ninebox3'
    | 'ninebox4'
    | 'ninebox5'
    | 'ninebox6'
    | 'ninebox7'
    | 'ninebox8'
    | 'ninebox9'
    | string[]
}

/** The Align component handles the flex box model, normalized for cross-platform with flutter like props. */
export const Align = styled(ViewBase<AlignProps>('Align'))`
  flex-wrap: nowrap;
  flex-direction: row;
  justify-content: ${(props) => alignmentToMainAxisDirection(props.alignment)};
  align-items: ${(props) => alignmentToCrossAxisDirection(props.alignment)};
  ${commonProps}
` as React.FC<AlignProps>
